module.exports = __webpack_public_path__ + "media/06_ASANBUDAPEST-BEATS06.c58cf848.mp3";